module.exports = __webpack_public_path__ + "static/media/risk-degree.2c35c6d9.svg";